import checkboxcheckedSvg from './checkbox-checked.svg';
import checkboxSvg from './checkbox.svg';
import Button from '@/shared/ui/Button';
import { StoredUtmTags } from '@/shared/utils/Stored';
import { captureException } from '@/modules/capture-exception';
import { notifyApiError } from '@/modules/notify-api-error';
import { useStateReducer } from '@/modules/use-state-reducer';
import { fetchApi } from '@/modules/sanr-api';
import { useProfile } from '@/routes/Providers/ProfileProvider';

export default function Content() {
  const { updateProfile } = useProfile();
  const [{ isCheckboxChecked, isSubmitting }, ss] = useStateReducer({
    isCheckboxChecked: false,
    isSubmitting: false,
  });

  const handleCheckboxClick = () => {
    if (isSubmitting) {
      return;
    }
    ss({ isCheckboxChecked: !isCheckboxChecked });
  };

  const handleSubmit = async () => {
    try {
      ss({ isSubmitting: true });
      await fetchApi('POST_ISSUER_GDPR');
      const utmTags = StoredUtmTags.get();
      if (utmTags) {
        await fetchApi('PUT_ISSUER', {
          signal: undefined,
          body: { utm: JSON.stringify(utmTags) },
        });
      }
      await updateProfile();
      ss({ isSubmitting: false });
    } catch (e) {
      captureException(e);
      notifyApiError(e);
      ss({ isSubmitting: false });
    }
  };

  return (
    <div className="w-120 rounded-sm bg-background-secondary p-3xl text-body-md max-md:w-full">
      <div className="text-center text-h2 font-bold text-gray-text">
        We value your privacy
      </div>
      <div className="mt-3xl text-body-md text-gray-text">
        {/* Plain <a>: SmartLink turns same-origin URLs into client-side
            Link navigation, which can never reach a static file. */}
        <span className="text-gray">Please review and accept our</span>{' '}
        <a
          className="inline-block whitespace-nowrap text-blue-default underline hover:opacity-80"
          href="/Privacy.pdf"
          rel="noopener noreferrer"
          target="_blank"
        >
          Privacy Policy
        </a>{' '}
        and{' '}
        <a
          className="inline-block whitespace-nowrap text-blue-default underline hover:opacity-80"
          href="/Terms.pdf"
          rel="noopener noreferrer"
          target="_blank"
        >
          Terms & Conditions
        </a>{' '}
        to continue using Score
        <button
          type="button"
          className="relative mt-3xl btn-reset block pl-11"
          onClick={handleCheckboxClick}
        >
          <span
            className="absolute top-1/2 left-0 rounded-xs"
            style={{
              transform: 'translateY(-50%)',
              backgroundImage: `url("${isCheckboxChecked ? checkboxcheckedSvg : checkboxSvg}")`,
              backgroundSize: 'cover',
              width: 24,
              height: 24,
            }}
          />
          I have read and accept the Score Privacy Policy and Terms & Conditions
        </button>
      </div>
      <div className="mt-3xl">
        <Button
          className="w-full"
          disabled={!isCheckboxChecked}
          loading={isSubmitting}
          onClick={() => {
            void handleSubmit();
          }}
          size="lg"
        >
          Done!
        </Button>
      </div>
    </div>
  );
}
